import { SET_USER_INFO } from "./actionContants";

/**
 * USER object structure
 * obj = {
 *     orgRole
 * }
 */

/**
 * Action for setting a user info
 * @param {Object} widget - An object similar to USER Object Structure
 */
export const setUserInfo = userInfo => ({
	type: SET_USER_INFO,
	userInfo
});
